module.exports = __webpack_public_path__ + "static/img/1_4_1.9fd6be74.jpg";